module.exports = __webpack_public_path__ + "img/approval-warning.4a75adfc.png";